import { BlogListPage } from './pages/BlogListPage';
import { BlogDetailPage } from './pages/BlogDetailPage';

export const blogRoutes = [
  { path: 'blogs', element: <BlogListPage /> },
  { path: 'blogs/:slug', element: <BlogDetailPage /> },
];
